module.exports = __webpack_public_path__ + "static/media/LA-live-event.a9dfa2c3.jpg";